<div class="Loading" *ngIf="showLoading==true">
    <div class="loader"></div>
    <label class="loaderlabel">Please wait while Processing....</label>
</div>


<!-- <div class="LoginSection animated slideInDown"> -->
<div class="LoginSection animated fadeIn slow" style="margin: 4%;">
    <div class="row">
        <div class="col-lg-3 col-md-3 hidden-xs hidden-sm">
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="Motor">

                <div class="row">


                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                        <div class="InsuredInformation Infomation">
                            <div class="Headertitle">
                                <span id="InsuredInfo">{{'Login'|translate}}</span>

                            </div>

                            <div class="FormSection RegFormView">

                                <form #loginFrm="ngForm">
                                    <div class="row">
                                        <div class="Msg">
                                            <div class="Clears"></div>
                                            <span class="Horizontal"></span>
                                        </div>
                                    </div>

                                    <div class="Login" *ngIf="!HasForgot && !showOTP">
                                        <div class="row">
                                            <div class="Field">
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                                        <label class="iqno">{{'ID number'|translate}}</label>
                                                    </div>
                                                    <div style="margin-bottom: 25px" class="col-lg-9 col-md-9 col-sm-9 col-xs-12 input-group loginforminputfield">

                                                        <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
                                                        <input type="text" class="form-control" placeholder="{{ 'ID number' | translate }}" required id="txtUserName" numbersOnly maxlength="10" minlength="10" name="txtUserName" [(ngModel)]="loginReqObj.IqamaNo" class="form-control" #txtUserName="ngModel" pattern="^[123]\d{9}$">
                                                    </div>
                                                    <div *ngIf="txtUserName.errors && (txtUserName.dirty || txtUserName.touched)" class="col-lg-12 errorvalidations text-danger valid">
                                                        <p *ngIf="txtUserName.errors.required">
                                                            {{'Id Number is required'|translate}}</p>
                                                        <p *ngIf="txtUserName.errors.pattern && txtUserName.invalid && txtUserName.touched">
                                                            {{'Id Number Must start with 1 or 2 and must be 10 digits'|translate}}
                                                        </p>
                                                    </div>


                                                </div>
                                            </div>


                                            <div class="Field">
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                                        <label class="otps">{{'Password'|translate}}</label>
                                                    </div>
                                                    <!-- <div style="margin-bottom: 25px" class="col-lg-9 col-md-9 col-sm-9 col-xs-12 input-group loginforminputfield">
                                                        <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
                                                        <input type="password" placeholder="{{ 'Password' | translate}}" required id="txtPassword"
                                                            name="txtPassword" [(ngModel)]="loginReqObj.Password" class="form-control"
                                                            #txtPassword="ngModel" maxlength="20" autocomplete="off">
                                                    </div> -->
                                                    <div style="margin-bottom: 25px" class="col-lg-9 col-md-9 col-sm-9 col-xs-12 input-group loginforminputfield">
                                                        <span class="input-group-addon">
                                                            <i *ngIf="!show" (click)="TogglePassword()" class="glyphicon glyphicon-eye-open"></i>
                                                            <i *ngIf="show" (click)="TogglePassword()" class="glyphicon glyphicon-eye-close"></i>
                                                        </span>
                                                        <input [type]="show ? 'text' : 'password'" placeholder="{{ 'Password' | translate}}" required id="txtPassword" name="txtPassword" [(ngModel)]="loginReqObj.Password" class="form-control" #txtPassword="ngModel" maxlength="20" autocomplete="off">
                                                    </div>
                                                    <div class="col-lg-12 errorvalidations text-danger valid" *ngIf="txtPassword.errors && (txtPassword.dirty || txtPassword.touched)">
                                                        <p *ngIf="txtPassword.errors.required">
                                                            {{'Password is required'|translate}}</p>

                                                    </div>


                                                </div>
                                            </div>



                                            <div class="Clears"></div>
                                            <div class="Actionsection">
                                                <div class="Actions">
                                                    <div class="btn-group">

                                                        <!-- <button type="button" class="btn btn-primary btns procced" -->
                                                        <!-- <button *ngIf="!showOTP" type="button" class="MiddleButton"
                                                            [disabled]="(!loginFrm.valid|| showOTP)" (click)="login()"> -->
                                                        <button *ngIf="!showOTP" type="button" class="MiddleButton" (click)="login(loginFrm.valid)">
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                            {{'Proceed'|translate}}</button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </form>

                                <!-- OTP START -->
                                <div class="Field">
                                    <div class="OTPForm" *ngIf="showOTP">
                                        <div class="Field">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <label class="Verifi">{{'Verification Code'|translate}}</label>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">


                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                            <input type="text" [(ngModel)]="otpReq.OTP" class="form-control" maxlength="6">
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                            <button type="button" class="VerifyButton" (click)="LoginResendOTP()" *ngIf="isResendShow">
                                                                <span></span>
                                                                <span></span>
                                                                <span></span>
                                                                <span></span>
                                                                {{'Resend'|translate}}</button>
                                                            <button type="button" class="VerifyButton" (click)="LoginVerifyOTP()" [disabled]="(otpReq.OTP?.length==0 || otpReq.OTP==null )">
                                                                <span></span>
                                                                <span></span>
                                                                <span></span>
                                                                <span></span>
                                                                {{'Verify'|translate}}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="Field" *ngIf="isShowTimer">
                                    <span class="quotelink">{{'You can Resend OTP in '}} <span class="time">{{ timeLeft }}</span>
                                        {{'Seconds'}}</span>
                                </div>
                                <!--  OTP END-->


                                <div class="ForgotDiv" *ngIf="HasForgot">
                                    <div class="row">
                                        <div class="Field">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                    <label class="iqno">{{'ID number'|translate}}</label>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <input type="text" numbersOnly class="form-control" name="txtIqama" id="txtIqama" [(ngModel)]="fgObj.IqamaNo">
                                                    <span *ngIf="txtIqama.errors && (txtIqama.dirty || txtIqama.touched)" class="text-danger valid">
                                                        <p *ngIf="txtIqama.errors.required">{{'ID No is
                                                            required'|translate}}</p>
                                                        <p *ngIf="txtIqama.errors.pattern">{{'ID No Must start with 1
                                                            or 2 and must be 10 digits'|translate}}
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>




                                        <div class="Field">

                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <div class="btn-group">
                                                        <!-- <button type="button" class="btn btn-primary btns procced" (click)="CancelForgot()">{{'Back'|translate}}</button> -->
                                                        <button type="button" class="btn btn-primary btns procced" id="btnFogetPass" name="btnForgetPass" (click)="forgetPass()">Proceed R</button>

                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>



                        </div>
                    </div>





                </div>


                <div class="Footer">
                    <a href="#/BeforeLogin/NewReg" class="already">{{'Do not have account? Click here'|translate}} </a>
                    <a (click)="ShowForgotPassowrdModal()" class="already" class="otpfor">{{'Forgot Password?'|translate}} </a>
                </div>




            </div>
        </div>

        <div class="col-lg-3 col-md-3 hidden-xs hidden-sm">


        </div>


    </div>
</div>



<div class="overlay animated zoomIn" *ngIf="ShowForgotPassowrd">
    <div class="popup">
        <!-- <div class="modal-content" style="margin-bottom: 30px !important;"> -->
        <div class="header" style="background-color: #004085;">
            <button type="button" class="close" (click)="HideForgotPassword()">X</button>
            <h4 class="modal-title logins" style="color: white;font-size: 14px !important;">
                {{'Forgot Password' | translate }}</h4>
        </div>
        <!-- <div class="modal-body"> -->
        <div class="FPbody">
            <form #NewMobileNumberForm="ngForm">
                <div class="Field">
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <label class="iqno lbltext">{{'ID Number'|translate}}</label>
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">



                            <div *ngIf="!NewMobileNumber" class="col-lg-9 col-md-9 col-xs-8 col-sm-9">
                                <input type="text" id="txtID" name="txtID" numbersOnly pattern="^[123]\d{9}$" maxlength="10" (keypress)="ValidateSpecialChar($event)" minlength="10" class="form-control" [(ngModel)]="fgObj.IqamaNo" #txtID="ngModel" (ngModelChange)="GetMobileNo(NewMobileNumberForm.valid)" [disabled]="OTPorChange">
                                <span *ngIf="txtID.errors && (txtID.dirty || txtID.touched)" class="text-danger valid">
                                    <p *ngIf="txtID.errors.required">{{'ID No is required'|translate}}</p>
                                    <p *ngIf="txtID.errors.pattern">
                                        {{'ID No Must start with 1 or 2 and must be 10 digits'|translate}} </p>
                                </span>
                            </div>
                            <div *ngIf="NewMobileNumber" class="col-lg-9 col-md-9 col-xs-8 col-sm-9">
                                <input type="text" id="txtID" name="txtID" class="form-control" placeholder="{{fgObj.IqamaNo}}" placeholder="fgObj.IqamaNo" [disabled]="OTPorChange">
                            </div>

                            <div class="col-lg-3 col-sm-3 col-md-3 col-xs-4">
                                <button type="button" id="btnFgPass" name="btnFgPass" class="btn btn-primary btns procced" (click)="forgetPass()" [disabled]="DisableProceed || fgObj.IqamaNo.length != 10">{{'Proceed'|translate}}</button>
                            </div>
                        </div>



                    </div>

                    <div class="row GetMobile" *ngIf="GetMobileNumber">
                        <div class="oldmobilediv">
                            <p>{{'Password will be sent to '| translate}}</p>
                            <p>{{OldMobileNumber}}</p>
                            <br>
                            <p class="oldmobilespan">
                                {{'Do you want to change your mobile number? Click below'| translate}}</p>
                        </div>
                        <div class="changemobilediv" *ngIf="ClickHere">
                            <button (click)="ChangeMobileNumber()" class="changemobilebtn"><span>{{'Update Mobile Number' | translate}}</span></button>
                        </div>
                    </div>

                    <div class="updatemobilecard" *ngIf="NewMobileNumber">

                        <div class="updatemobilerow">
                            <span class="updatemobilenoheading">{{'Update Mobile Number'| translate}}</span>
                        </div>
                        <div class="row newmobilenumber">
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 newmobilelabel">
                                <label class="newmobilelabelheading">{{'New Mobile Number' | translate}}</label>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12 newmobileinput">
                                <input type="text" class="form-control" name="txtNewMobile" (change)="YakeenMobileNoVerify()" pattern="^5\d{8}$" id="txtNewMobile" [disabled]="isLockFields" required numbersOnly [(ngModel)]="objmdlVerifyDetailsReq.NewMobileNo" #txtNewMobile="ngModel" placeholder="5XXXXXXXX" minlength="9" maxlength="9" (keypress)="ValidateSpecialChar($event)">
                                <span *ngIf="txtNewMobile.errors && (txtNewMobile.dirty || isUpdate || txtNewMobile.touched)" class="text-danger valid">
                                    <p *ngIf="txtNewMobile.errors.required">
                                        {{'New mobile Number is required'|translate}}</p>
                                    <p *ngIf="txtNewMobile.errors.pattern">
                                        {{'Mobile Number must be like (05XXXXXXXX)'|translate}} </p>
                                </span>
                            </div>
                        </div>
                        <div class="row idexpiry">
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 idexpirylabel">
                                <label class="idexpirylabelheading" *ngIf="fgObj.IqamaNo?.startsWith('1')">{{'Date of Birth Hijri' | translate}}</label>
                                <label class="idexpirylabelheading" *ngIf="fgObj.IqamaNo?.startsWith('2')">{{'Date of Birth' | translate}}</label>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <input type="text" class="form-control" name="txtMM" id="txtMM" placeholder="MM" [disabled]="isLockFields" required numbersOnly maxlength="2" minlength="2" [(ngModel)]="MM" #txtMM="ngModel" [CustomMonthDirective] (keypress)="ValidateSpecialChar($event)">
                                        <span *ngIf="txtMM.errors && (txtMM.dirty || isUpdate || txtMM.touched)" class="text-danger valid">
                                            <p *ngIf="txtMM.errors.required">{{'MM is required'|translate}}</p>
                                            <p *ngIf="txtMM.errors.minlength">{{'MM Must be two digits'|translate}} </p>
                                            <p *ngIf="txtMM.errors.CustomMonthDirective">{{'Invalid Month'|translate}}
                                            </p>
                                        </span>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <input type="text" class="form-control" name="txtYY" id="txtYY" placeholder="YYYY" [disabled]="isLockFields" required numbersOnly maxlength="4" minlength="4" [(ngModel)]="YY" #txtYY="ngModel" YearCustomValidation={{fgObj.IqamaNo}} (keypress)="ValidateSpecialChar($event)">
                                        <span *ngIf="txtYY.errors && (txtYY.dirty || isUpdate || txtYY.touched)" class="text-danger valid">
                                            <p *ngIf="txtYY.errors.required">{{'YYYY is required'|translate}}</p>
                                            <p *ngIf="txtYY.errors.minlength"> {{'YYYY Must be Four digits'|translate}}
                                            </p>
                                            <p *ngIf="txtYY.errors.YearCustomValidation">
                                                {{ 'Invalid Year' | translate }}</p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 idexpirybtn">
                                <button type="button" class="btn btn-primary updatemobilenumber" [disabled]="isLockFields" (click)="UpdateMobile(NewMobileNumberForm.valid)">{{'Update' | translate}}</button>
                            </div>
                        </div>

                        <div class="row otpsuccess" *ngIf="isOTP">
                            <div class="row verifyotp">
                                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 enterotp">
                                    <label class="verifyotplabel">{{'Enter OTP' | translate}}</label>
                                </div>
                                <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12 enterotpinput" style="padding-left: 0px;">
                                    <input type="text" class="form-control" [(ngModel)]="OTP" maxlength="6" id="txtOTP" name="txtOTP" numbersOnly (keypress)="ValidateSpecialChar($event)">
                                </div>
                            </div>
                            <div class="flex flexbuttons">
                                <div class="otpbtns enterotpbtn">
                                    <button class="btn btn-primary verifyotpbtn" [disabled]="OTP==''|| OTP==undefined" type="button" (click)="VerifyOTP()">{{'Verify' | translate}} </button>
                                    <button class="btn btn-primary verifyotpbtn" type="button" *ngIf="isResendShow" (click)="ResendOTP()">{{'Resend' | translate}}</button>
                                </div>
                            </div>
                            <div class="row">
                                <p class="otps">You can resend OTP in {{timeLeft}} seconds</p>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
        <!-- </div> -->
        <!-- </div> -->
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Login/Login.html